import { render, staticRenderFns } from "./MapCoordinates.vue?vue&type=template&id=334c173a&"
import script from "./MapCoordinates.vue?vue&type=script&lang=js&"
export * from "./MapCoordinates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports